export default __webpack_public_path__ + "static/media/Login.8749620f.png";